import axios from "axios";
import store from "@/store";
import jwt_decode from 'jwt-decode';

axios.defaults.baseURL = process.env.VUE_APP_AUDIT_API_BASE_URL + "/";

const authApiBaseUrl = axios.create({
	baseURL: process.env.VUE_APP_AUTH_API_BASE_URL + "/",
});

// Add a request interceptor
axios.interceptors.request.use(function (config) {
	const token = store.state.auth.accessToken;
	config.headers = {
		Authorization: `Bearer ${token}`,
		Accept: "application/json",
		"Content-Type": "application/json",
	};

	return config;
});

// https://gist.github.com/Godofbrowser/bf118322301af3fc334437c683887c5f
// https://stackoverflow.com/questions/57890667/axios-interceptor-refresh-token-for-multiple-requests
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
	failedQueue.forEach(prom => {
			if (error) {
				prom.reject(error);
			} else {
				prom.resolve(token);
			}
	});

	failedQueue = [];
};

axios.interceptors.response.use(
	function (response) {
		return response;
	},
	async function (error) {
		const originalRequest = error.config;

		//parse error message when response type is blob
		if (
			error.request.responseType === "blob" &&
			error.response.data instanceof Blob &&
			error.response.data.type &&
			error.response.data.type.toLowerCase().indexOf("json") != -1
		) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader();
				reader.onload = () => {
					error.response.data = JSON.parse(reader.result);
					resolve(Promise.reject(error));
				};

				reader.onerror = () => {
					reject(error);
				};

				reader.readAsText(error.response.data);
			});
		}
		
		if (error.response.status === 401 && !originalRequest._retry) {
			
			if (isRefreshing) {
				return new Promise(function(resolve, reject) {
						failedQueue.push({ resolve, reject });
				})
				.then(token => {
					originalRequest.headers['Authorization'] = 'Bearer ' + token;
					return axios(originalRequest);
				})
				.catch(err => {
					return Promise.reject(err);
				});
			}

			originalRequest._retry = true;
         isRefreshing = true;

			let data = {
				id: store.state.auth.jwtPayload.user_id,
				access_token: store.state.auth.accessToken,
				refresh_token: store.state.auth.jwtPayload.jwt_refresh_token
			}

			return new Promise(function(resolve, reject) {
				axios.post('/auth/token/refresh', data)
					.then((response) => {
						store.commit("auth/setAccessToken", response.data.user.access_token);
						store.commit("auth/setJwtPayload", jwt_decode(response.data.user.access_token));
						axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.user.access_token;
						originalRequest.headers['Authorization'] = 'Bearer ' + response.data.user.access_token;

						processQueue(null, response.data.user.access_token);
						resolve(axios(originalRequest));
					})
					.catch(err => {
						processQueue(err, null);
						
						reject(err);
						
						if (typeof window !== 'undefined' && window.location.pathname !== '/' && window.location.pathname !== '/validation') {
							const currentPath = window.location.pathname + window.location.search + window.location.hash;
							store.commit("auth/setRedirectLink", currentPath);
							sessionStorage.setItem("redirectLink", currentPath);
						}

						if (store.state.auth.currentOrganisation && store.state.auth.currentOrganisation.id && typeof sessionStorage !== 'undefined') {
							sessionStorage.setItem("selectedOrgId", store.state.auth.currentOrganisation.id);
						}

						store.commit("auth/setIsTokenExpired");
						store.dispatch("auth/logout");
					})
					.finally(() => {
						isRefreshing = false;
					});
			});

			
		}

		

		return Promise.reject(error);
	}
);

// ===== AUTH API =====
// Add a request interceptor
authApiBaseUrl.interceptors.request.use(function (config) {
	const token = store.state.auth.accessToken;
	config.headers = {
		Authorization: `Bearer ${token}`,
		Accept: "application/json",
		"Content-Type": "application/json",
	};

	return config;
});

authApiBaseUrl.interceptors.response.use(
	function (response) {
		return response;
	},
	async function (error) {
		const originalRequest = error.config;

		if (error.response.status === 401 && !originalRequest._retry) {
			if (typeof window !== 'undefined' && window.location.pathname !== '/' && window.location.pathname !== '/validation') {
				const currentPath = window.location.pathname + window.location.search + window.location.hash;
				store.commit("auth/setRedirectLink", currentPath);
				sessionStorage.setItem("redirectLink", currentPath);
			}

			if (store.state.auth.currentOrganisation && store.state.auth.currentOrganisation.id && typeof sessionStorage !== 'undefined') {
				sessionStorage.setItem("selectedOrgId", store.state.auth.currentOrganisation.id);
			}

			store.commit("auth/setIsTokenExpired");
			store.dispatch("auth/logout");
		}

		return Promise.reject(error);
	}
);

export default {
	install: (app) => {
		app.config.globalProperties.$axios = axios;
		app.config.globalProperties.$axios_auth = authApiBaseUrl;
	},
}
